import { mqMax } from '../../theme/base';
import styled from '../../theme/styled';

interface LucidContainerProps {
  as?: 'div' | 'section' | 'header' | 'main';
  customPadding?: number;
  extraPadding?: number;
  flex?: boolean;
  noSidePadding?: boolean;
}

const LucidContainer = styled.div<LucidContainerProps>(({
  customPadding,
  noSidePadding,
  extraPadding,
  flex
}: LucidContainerProps) => ({
  label: 'lucidContainer',
  display: flex ? 'flex' : 'block',
  position: 'relative',
  maxWidth: '90rem',
  width: '100%',
  margin: '0 auto',
  padding: noSidePadding
    ? 0
    : extraPadding
      ? `0 ${customPadding
        ? customPadding
        : 7.5 + extraPadding}rem`
      : `0 ${customPadding
        ? `${customPadding}rem`
        : '7.5rem'}`,
  WebkitFontSmoothing: 'antialiased',
  justifyContent: 'space-between',
  [mqMax.computer]: {
    paddingLeft: noSidePadding ? 0 : '3.75rem',
    paddingRight: noSidePadding ? 0 : '3.75rem'
  },
  [mqMax.tabletSmall]: {
    paddingLeft: noSidePadding ? 0 : '1.875rem',
    paddingRight: noSidePadding ? 0 : '1.875rem'
  }
}));

export default LucidContainer;
